import React, { useCallback, useEffect, useState, useContext } from 'react';
import Tabs from '../components/Tabs';
import { Button, Grid } from '@mui/material';
import fieldsTables from '../utils/fieldsTables';
import showColumns from '../utils/showColumns';
import Table from '../components/Table';
import { useSearchParams } from 'react-router-dom';
import EmptyState from '../components/EmptyState';
import Loading from '../components/Loading';
import { LanguageContext } from '../App';
import { getNovidades, updateNovidadeStatus, deleteNovidade } from '../apis/apiNovidade';
import InputCustom from '../components/InputCustom';
import ballotIcon from '../assets/imgs/ballotIcon.svg'

function Novidades() {
  const [loading, setLoading] = useState<boolean>(true)
  const [selectedTab, setSelectedTab] = useState<string>("");
  const [novidades, setNovidades] = useState<Novidade[]>([])
  const [novidadesFiltrados, setNovidadesFiltrados] = useState<Novidade[]>([])
  const [buscaNovidade, setBuscaNovidade] = useState("");
  const [searchParams] = useSearchParams();
  const { translations, setLanguage } = useContext(LanguageContext);

  const handleChangeTab = (event: React.SyntheticEvent, value: string) => {
    setSelectedTab(value);
  };

  const handleGetNovidades = useCallback(async (filters: FiltersType) => {
    setLoading(true)

    const params = {
      genericStatus: filters.genericStatus
    }

    const token = searchParams.get('token')

    const result = await getNovidades(params, token);

    if (result.status === 200) {
      setNovidades(result.data);
      setNovidadesFiltrados(result.data)
    }

    setLoading(false)
    
  }, [searchParams]);

  const handleDeleteNovidade = async (idNovidade: number) => {

    if (idNovidade) {

      const token = searchParams.get('token')

      const result = await deleteNovidade(token, idNovidade.toString());

      if (result.status === 200) {
        setNovidades(novidades.filter(novidade => novidade.idNovidade !== result.data.toString()))
        setNovidadesFiltrados(novidadesFiltrados.filter(novidade => novidade.idNovidade !== result.data.toString()))
      }
    }
  }

  const handleUpdateNovidadeStatus = async (novidade: Novidade) => {

    if (novidade.idNovidade) {

      const token = searchParams.get('token')

      const result = await updateNovidadeStatus({ status: !novidade.ativo}, token, novidade.idNovidade.toString());

      if (result.status === 200) {
        setNovidades(novidades.map((novidade: Novidade) => {
          if (novidade.idNovidade === result.data.idNovidade) {
            return {...novidade, ativo: result.data.ativo }
          }
          return novidade
        }))
        setNovidadesFiltrados(novidadesFiltrados.map((novidade: Novidade) => {
          if (novidade.idNovidade! === result.data.idNovidade) {
            return {...novidade, ativo: result.data.ativo }
          }
          return novidade
        }))
      }
    }
  }

  const handleBuscaNovidade = (event: any) => {
    const {
      target: { value },
    } = event;

    setBuscaNovidade(value)
    if (value.length > 0) {
      const valueSplit = value.toString().toUpperCase().split(" ");
      setNovidadesFiltrados(novidades.filter((novidade: Novidade) => (
        (novidade.idNovidade!).toString().includes(value.toString()) ||
        valueSplit.every((split: string) => novidade.descricaoPt.includes(split))
      )))
    } else {
      setNovidadesFiltrados(novidades)
    }
  };

  useEffect(() => {

    if (selectedTab !== "") {
      handleGetNovidades({
        genericStatus: ''
      });
    }

  }, [handleGetNovidades, selectedTab]);

  useEffect(() => {

    const initialTab = searchParams.get('indicador') || "listar_novidades"
    const languageParam = searchParams.get('language') || 'pt'
    setLanguage(languageParam)
    setSelectedTab(initialTab)

  }, [searchParams, setLanguage]);

  const handleCadastrarButton = () => {
    const language = searchParams.get('language') || 'pt'
    const token = searchParams.get('token');
    window.location.href = `../cadastros/novidade?acao=novo&token=${token}&language=${language}`
  }

  return (
    <Grid container justifyContent="center">
      { translations &&
        <Grid item xs={12}>
          <div className="page-body">
            <span className="page-title">
              Novidades e Avisos
            </span>
            <Grid container rowSpacing={2} justifyContent="center">
              <Grid item xs={12} display={"none"}>
                { selectedTab &&
                  <Tabs handleChange={handleChangeTab} value={selectedTab} labels={[{ label: translations["lbl.react.usuarios"], name: "listar_novidades" }]}/>
                }
              </Grid>
              <Grid container item xs={12} mt={2} justifyContent="end">
                <Button onClick={() => handleCadastrarButton()} startIcon={<img src={ballotIcon} alt="novo cadastro icon" />} className="btn-primario" variant="contained" >Cadastrar Novidade/Aviso</Button>
              </Grid>
              { loading === false ?
                <Grid item xs={12} pt={0}>
                  <Grid container item xs={12} justifyContent={"end"}>
                    <Grid item xs={4}>
                      <span className="input-label">{`${translations["lbl.react.buscar"]}:`}</span>
                      <InputCustom
                        placeholder={''}
                        controlledValue={buscaNovidade}
                        name={'buscaNovidade'}
                        handleChange={handleBuscaNovidade}
                      />
                    </Grid>
                  </Grid>
                  {selectedTab === "listar_novidades" && (
                    1>0 ?
                      <div>
                        <Grid item xs={12}>
                          <Grid container item xs={12} pb={2} mb={3}>
                            <Table
                              columns={fieldsTables(translations, handleDeleteNovidade, handleUpdateNovidadeStatus).novidades}
                              rows={novidadesFiltrados}
                              idColumn='idNovidade'
                              sortColumn='idNovidade'
                              sortOrder="desc"
                              hasCheckbox={false}
                              tableTitle={""}
                              tableSubTitle={""}
                              name="novidades"
                              printButton={false}
                              showColumns={showColumns.novidades}
                              handleCloseTable={() => {}}
                              border={false}
                            />
                          </Grid>
                        </Grid>
                      </div>
                    :
                      <div>
                        <EmptyState />
                      </div>
                    )
                  }
                </Grid>
                :
                <Loading />
              }
            </Grid>
          </div>
        </Grid>
      }
    </Grid>
  );
}

export default Novidades;